import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/components/layout/ScrollablePageLayout.tsx");
